const knTranslations = {
  mla_elec: "ಶಾಸಕರ ಚುನಾವಣೆ",
  acb: "ಬೆಂಗಳೂರಿನ ವಿಧಾನಸಭಾ ಕ್ಷೇತ್ರಗಳು",
  gcl: "ಪ್ರಸ್ತುತ ಸ್ಥಳವನ್ನು ಪಡೆಯಿರಿ",
  or: "ಅಥವಾ",
  sac: "ವಿಧಾನಸಭಾ ಕ್ಷೇತ್ರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
  About: "ವಿವರಗಳು",
  vp: "ಮತದಾನದ ಜನಸಂಖ್ಯೆ",
  lakh: "ಲಕ್ಷ",
  area: "ಪ್ರದೇಶ",
  sqkm: "ಚ.ಕಿ.ಮೀ",
  party: "ರಾಜಕೀಯ ಪಕ್ಷ",
  Name: "ಹೆಸರು",
  smla: "ಹಾಲಿ ಶಾಸಕ",
  news: "ವಾರ್ತೆಯಲ್ಲಿ",
  Candidates: "ಸ್ಪರ್ಧಿಗಳು",
  loc_err: "ಪ್ರಸ್ತುತ ಸ್ಥಳವನ್ನು ಪಡೆಯಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ",
  loc_fetch: "ಪ್ರಸ್ತುತ ಸ್ಥಳವನ್ನು ಪಡೆಯಲಾಗುತ್ತಿದೆ",
  loc_out: "ನಿಮ್ಮ ಸ್ಥಳ ಬೆಂಗಳೂರಿನ ಹೊರಗಿರುವಂತೆ ತೋರುತ್ತಿದೆ. ದಯವಿಟ್ಟು ಡ್ರಾಪ್‌ಡೌನ್‌ನಿಂದ ಕ್ಷೇತ್ರವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  inc: "ಕಾಂಗ್ರೆಸ್",
  bjp: "ಬಿಜೆಪಿ",
  jds: "ಜೆಡಿಎಸ್",
  aap: "ಎಎಪಿ",
  wv: "ನಾನು ನನ್ನ ಮತವನ್ನು ಎಲ್ಲಿ ಹಾಕಬೇಕು",
  scs: "ಮೂಲಗಳು",
  cm: "ನಾಗರಿಕ ವಿಷಯಗಳಲ್ಲಿ ನಿಮ್ಮ ಅಭ್ಯರ್ಥಿಗಳು ಮತ್ತು ಸ್ಥಳೀಯ ಚುನಾವಣಾ ಸಮಸ್ಯೆಗಳ ಕುರಿತು ಇನ್ನಷ್ಟು ಓದಿ",
  voter_search: "ರಾಷ್ಟ್ರೀಯ ಮತದಾರರ ಸೇವಾ ಪೋರ್ಟಲ್‌ನೊಂದಿಗೆ ನಿಮ್ಮ ಮತಗಟ್ಟೆಯನ್ನು ಪತ್ತೆ ಮಾಡಿ",
  "2018": "೨೦೧೮",
  "2019": "೨೦೧೯",
  "2023": "೨೦೨೩",
  ai: "ಇತರೆ ಮಾಹಿತಿ",
};

export default knTranslations;
